"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenReplacement = void 0;
var _escape = require("./expressions/escape");
var _number = require("./type-checks/number");
var _string = require("./type-checks/string");
var tokenReplacement = exports.tokenReplacement = function tokenReplacement(initial, token, replacement) {
  var returnVal = initial;
  if (((0, _string.isString)(replacement) || (0, _number.isNumber)(replacement)) && new RegExp((0, _escape.escape)(token)).test(initial)) {
    returnVal = initial.replaceAll(token, replacement);
  }
  return returnVal;
};